export const RECAPTCHA_SITE_KEY = "6LcP86gsAAAAAHxK1WctA1YUeGLFOBIkv4d8Mrmj";

/** Execute reCAPTCHA v3 and return a token. Returns "" on failure. */
export async function getRecaptchaToken(action) {
  try {
    return await new Promise((resolve, reject) => {
      const attempt = () => {
        if (window.grecaptcha && window.grecaptcha.ready) {
          window.grecaptcha.ready(() => {
            window.grecaptcha
              .execute(RECAPTCHA_SITE_KEY, { action })
              .then(resolve)
              .catch(reject);
          });
        } else {
          setTimeout(attempt, 150);
        }
      };
      attempt();
    });
  } catch {
    return "";
  }
}
